/* 🤖 this file was generated by svg-to-ts */
export const sbIconsChevronUp: {
  name: 'chevron-up';
  data: string;
} = {
  name: 'chevron-up',
  data: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20"><path fill="currentColor" d="m19.4834 12.686-8.1579-8.06277a1.902 1.902 0 0 0-.6188-.41624 1.9016 1.9016 0 0 0-2.08144.41624L.56249 12.686a1.902 1.902 0 0 0-.41624.6188A1.902 1.902 0 0 0 0 14.0361c0 .2511.0497.4996.14625.7313.09654.2318.238.4421.41624.6189a1.9018 1.9018 0 0 0 1.34062.5529c.50238 0 .98434-.1988 1.34063-.5529l6.73165-6.73168L16.707 15.3863c.3542.3513.8323.5493 1.3312.5514a1.9013 1.9013 0 0 0 1.3501-.5514 1.902 1.902 0 0 0 .4384-.6041c.1048-.2283.1633-.4752.1721-.7262a1.9 1.9 0 0 0-.1206-.7366 1.904 1.904 0 0 0-.3948-.6334"/></svg>`
};
